import { apiArchiveProposal } from '@api/proposal/apiProposal';
import { eventBus } from '@tools/event-bus';
import { flashBagError, flashBagSuccess } from '@tools/flashbag';
import { Requests } from '@tools/requests';
import { Logger } from '@tools/logger/logger';
import { translations } from '@tools/translations/translations';
import { trans } from '@elements/translation';
import { momentMixin } from '@tools/moment';
import { URL_OFFER_PROPOSAL_ADD } from '@tools/routes/routes';
import { OFFER_EVENT } from '@organisms/offer/constants';
import { SelectionItemEvent, Slider } from '@enums/event';
import { FAVORITE_PROPOSAL_EVENT, PROPOSAL_EVENT } from './constants';

function dispatchEvent(event, data = {}) {
  eventBus.dispatchEvent(
    new CustomEvent(event, { detail: data }),
  );
}

async function callAddProposalApi({
  hashIds,
  teamSize,
  comment,
  sendMail,
  teamSizeList = null,
  attachments,
}) {
  let response;

  try {
    response = await Requests.post(URL_OFFER_PROPOSAL_ADD, {
      hashIds,
      teamSize,
      comment,
      sendMail,
      teamSizeList,
      attachments,
    });
  } catch (error) {
    flashBagError();
    Logger.error(error);
    return;
  }

  if (!response || response.status !== 200 || !response.data) {
    flashBagError();
    Logger.error('Proposal backend call, response nok');
    return;
  }

  const {
    success = false, proposalId = null, pipedriveUser = {}, label = '',
  } = response.data;

  if (!success) {
    return;
  }

  dispatchEvent(FAVORITE_PROPOSAL_EVENT.OFFER_PROPOSAL_TOGGLE_CALLBACK, {
    label,
    message: comment,
    date: momentMixin.methods.getSimpleDate(new Date().toISOString()),
    pipedriveUser,
  });
  dispatchEvent(PROPOSAL_EVENT.ADDED, { proposalId, offersHashId: hashIds });

  flashBagSuccess(trans('sliders.offer_proposal.flashbag_success'));
}

async function callArchiveProposalApi({ proposalId, offersHashId }) {
  const isArchived = await apiArchiveProposal(proposalId);

  if (!isArchived) {
    return;
  }

  dispatchEvent(PROPOSAL_EVENT.REMOVED, { proposalId, offersHashId, refusedByUser: false });
  flashBagSuccess(trans('selection_item.proposal.flashbag.archived'));
}

export const init = () => {
  eventBus.addEventListener(
    SelectionItemEvent.ADD_PROPOSAL,
    (event) => {
      const { offersHashId, teamSize, teamSizeList } = event.detail;
      const menuSelector = document.querySelector('.menu-auth');

      if (menuSelector?.dataset?.isSeller === '1') {
        // eslint-disable-next-line no-alert
        const confirm = window.confirm(translations.messages['proposal.added.not_seller_user']);
        if (!confirm) {
          dispatchEvent(FAVORITE_PROPOSAL_EVENT.CANCEL_PROPOSAL_ADDITION);
          return;
        }
      }

      dispatchEvent(OFFER_EVENT.SLIDER_SHOW, {
        sliderType: Slider.CREATE_PROPOSAL,
        sliderPayload: {
          hashIds: offersHashId,
          teamSize,
          teamSizeList,
        },
      });
    },
  );

  eventBus.addEventListener(
    SelectionItemEvent.ARCHIVE_PROPOSAL,
    async (event) => {
      const { proposalId, offersHashId } = event.detail;
      await callArchiveProposalApi({ proposalId, offersHashId });
    },
  );

  eventBus.addEventListener(FAVORITE_PROPOSAL_EVENT.OFFER_SAVE_PROPOSAL, async (event) => {
    const { hashIds, teamSize, comment, sendMail, teamSizeList, attachments } = event.detail;
    await callAddProposalApi({
      hashIds,
      teamSize,
      comment,
      sendMail,
      teamSizeList,
      attachments,
    });
  });
};
